import { observable } from 'mobx'

import { AppFailureCodeSchema, ProtocolFailureCodeSchema } from '@authy/lib-common/entities'
import { z } from '@authy/lib-common/utils/zod'
import { client } from '@authy/lib-client/trpc'

import { appState } from '@/appState'

export const FilterSchema = z.object({
    fromCreatedAt: z.coerce.date().optional(),
    toCreatedAt: z.coerce.date().optional(),
    kind: z.enum(['all', 'app', 'protocol']).default('all'),
    code: z.union([AppFailureCodeSchema, ProtocolFailureCodeSchema, z.literal('all')]).default('all'),
})

export const SearchSchema = FilterSchema.extend({
    searchTerm: z.string().optional(),
    sort: z.enum(['createdAt', 'trackId', 'ipAddress']).default('createdAt'),
    sortBy: z.enum(['asc', 'desc']).default('desc'),
})

export type Search = z.infer<typeof SearchSchema>

export const createDefaultFilter = () => ({
    ...FilterSchema.parse({}),
    fromCreatedAt: undefined,
    toCreatedAt: undefined,
})

export const listFailureLogs = async (search: Search, offset: number, abortController?: AbortController) => {
    const result = await client.failureLogs.listFailureLogs.query(
        {
            tenantId: appState.tenant!._id.toString(),
            searchTerm: search.searchTerm,
            fromCreatedAt: search.fromCreatedAt,
            toCreatedAt: search.toCreatedAt,
            kind: search.kind === 'all' ? undefined : search.kind,
            code: search.code === 'all' ? undefined : search.code,
            sort: { [search.sort]: search.sortBy },
            offset,
            limit: 50,
            returnCount: offset === 0,
        },
        { signal: abortController?.signal }
    )

    return observable(result)
}
